import React from "react";
import AdminDashboard from "../components/AdminDashboard";

const Admin = () => {
    return (
        <div>
            <AdminDashboard />
        </div>
    )
};

export default Admin
